// extracted by mini-css-extract-plugin
export default {"cartContainer":"FT","summarycontent":"GT","offset":"HT","leaf":"IT","summaryclosed":"JT","summaryheader":"KT","summaryitems":"LT","summaryprice":"MT","buttonopen":"NT","buttondown":"OT","summaryfixed":"PT","usdnotification":"QT","renew":"RT","promowrapper":"ST","ordersummarywrap":"TT","simplewrap":"UT"};
    if(module.hot) {
      // 1721922365361
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  